import Style from "./styles"

const Loading = () => {
    return (
        <Style.LoadingDiv>
            <Style.Loader />
        </Style.LoadingDiv>
    )
}

export default Loading